
import constants from '@/util/constants'
export const ehEmpresaOffice = ({ formulario }) => !!(formulario.id_contexto === constants.contextoEmpresa.office)
